<script>
  import {helpStore} from '../../stores/help-store';

  const onClickMario = () => {
    helpStore.change(null);
  };
</script>

<style>
  .bubble {
    background: #aef;
    border-radius: .4em;
    float: left;
    height: 130px;
    line-height: 1.4;
    margin-right: 20px;
    padding: 10px 20px;
    position: relative;
    transition: box-shadow 0.5s;
    width: 530px;
  }

  :global(.bubble.glow) {
    box-shadow: 0 0 10px 5px #80b2ff;
  }

  .bubble:after {
    border: 20px solid transparent;
    border-left-color: #aef;
    border-right: 0;
    border-top: 0;
    content: '';
    height: 0;
    margin-right: -20px;
    margin-top: -10px;
    position: absolute;
    right: 0;
    top: 45%;
    width: 0;
  }

  h2 {
    font-size: 1em;
    font-weight: bold;
  }

  .mario {
    cursor: pointer;
  }
</style>

<template lang="pug" src="./help.pug"></template>
